import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import useDebouncedFunc from '../../../../../hooks/useDebounsedFunc';

export const SearchInput = ({ value, onChange, delay = 1000, ...props }) => {
  const [innerValue, setInnerValue] = useState(value);
  const debouncedOnChange = useDebouncedFunc((v) => {
    onChange(v);
  }, delay);
  const innerOnChange = (v) => {
    setInnerValue(v);
    debouncedOnChange(v);
  };
  return (
    <Input
      {...props}
      value={innerValue}
      onChange={(e) => innerOnChange(e.target.value)}
    />
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
